/**ф-ция проверяет является ли аргумент коректной hex строкой цвета */
export const checkColor=(val)=>{
    if(typeof val !== 'string' || !(val.length===4 || val.length===7)) return false
    const isHexDigit=(d)=>('1234567890abcdef'.includes(d.toLocaleLowerCase()))
    if(val.substring(0,1)!=='#') return false
    const tmpval=val.substring(1);
    for(const d of tmpval)if(!isHexDigit(d))return false;
    return true
}

/**
 * Превращает на основании справочника directory переданные число - в объект, массив - в массив объектов
 * Достойно обрабатывает ситуацию когда в directory отсутствует id встреыенный в maped
 * @param {number|number[]} maped 
 * @param {{id:number, label:string}[]} directory 
 */
export const statusMaper=(maped, directory)=>{
  const baseArr = Array.isArray(directory)?directory:[];
  const maper = (findId)=>{
    return baseArr.find(({id})=>id===findId) || {id:findId, label:'Неизвестный'}
  }
  if(Array.isArray(maped)){
    return maped.map(maper)
  }else{
    return maper(maped)
  }
}
/**Возвращает объект Date эквивалентный началу дня переданного в качестве аргумента
 * если аргумен не передать - возвращает начало сегодня
 * @param {Date|undefined} дата начало которой хотим получить 
 */
export const getNowStart = (date = new Date()) => {
  return new Date(...getNowArray(date));
}

/**Возвращает объект Date эквивалентный концу дня переданного в качестве аргумента
 * если аргумен не передать - возвращает конец сегодня
 * @param {Date|undefined} дата конец которой хотим получить 
 */
export const getNowEnd = (date = new Date()) => {
  const tomorrowArr = [...getNowArray(date)]
  tomorrowArr[2]++;
  const result = new Date(...tomorrowArr,0,0,0,-1);
  return result
}

const getNowArray = (now = new Date()) => {
  const nowArr = [
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  ]
  return nowArr;
}

/**форматирует екунды во время */
export const getFormatedTime = (seconds, enableDay = false) => {
  const sec = seconds % 60
  const fullMin = (seconds - sec) / 60
  const min = fullMin % 60
  const fullHour = (fullMin - min) / 60
  const hour = fullHour % 24
  const day = (fullHour - hour) / 24
  const get2DigitFormatString = (someNumber) => {
      const intNum = parseInt(someNumber)
      if (intNum < 1) return '00';
      if (intNum < 10) return `0${intNum}`
      return `${intNum}`
  }
  if (!enableDay || !day) {
      return `${fullHour}:${get2DigitFormatString(min)}.${get2DigitFormatString(sec)}`
  } else {
      return `${day}д, ${get2DigitFormatString(hour)}:${get2DigitFormatString(min)}.${get2DigitFormatString(sec)}`
  }
}